<template>
  <div class="vx-row mb-6">
    <div class="vx-col sm:w-1/5 w-full">
      <span>Points</span>
    </div>
    <div class="vx-col sm:w-4/5">
      <vs-input-number min="1" v-model="points"  style="width:100px"/>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action", "automationId"],
  data() {
    return {
      points: 1,
    };
  },
  methods: {
    render() {
      return {
        points: parseInt(this.points),
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
    }),
  },
  async mounted() {
    if (this.action) {
      this.points = parseInt(this.action.points);
    }
  },
};
</script>

<style lang="scss">
</style>